import React from 'react'
import { Container, Row } from 'reactstrap'
import JobsHeroImage from '../../../../assets/images/jobs-hero.jpg'
import SearchForm from '../SearchForm'
import {
  HeroContainer,
  Hero,
  HeroBody,
  Content,
  Title,
  ButtonLink
} from './styles'

export default ({ history }) => (
  <HeroContainer>
    <Hero backgroundImg={JobsHeroImage}>
      <HeroBody>
        <Container>
          <Row>
            <Content>
              <Title>Find Your Next Job</Title>
              <SearchForm />
              <ButtonLink onClick={() => history.push('/search')}>Advanced Search</ButtonLink>
            </Content>
          </Row>
        </Container>
      </HeroBody>
    </Hero>
  </HeroContainer>
)
